import { useEffect, useRef, useState } from "react";
import {
  Modal,
  Form,
  Container,
  Content,
  Button,
  Schema,
  Loader,
  SelectPicker,
  Input,
  FlexboxGrid,
  RadioGroup,
  Radio,
  DatePicker,
} from "rsuite";
import { updateIn } from "json-immut";
import { StringType, NumberType } from "schema-typed";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import {
  messageTypeArr,
  serviceRatingObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import React from "react";
import { isNotEmpty } from "../../../utils/helpers";
import { OrderServices } from "../../../core/services/OrderServices";
import { get } from "lodash/fp";
import OrderServiceRateItems from "./OrderServiceRateItems";

const Textarea = React.forwardRef((props: any, ref: any) => (
  <Input {...props} as="textarea" ref={ref} />
));

const RateOrder = ({
  openModal,
  setOpenModal,
  orderObj,
  onServeOrder,
  permission,
}: {
  openModal: boolean;
  setOpenModal: any;
  orderObj: any;
  onServeOrder: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const formRef = useRef<any>();
  const [showServiceDetails, setShowServiceDetails] = useState(false);
  const toggleServiceDetails = () => setShowServiceDetails(!showServiceDetails);
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [orderServiceItems, setOrderServiceItems] = useState<any[]>(
    orderObj?.order_service_items,
  );
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [serviceRatingVal, setServiceRatingVal] = useState(
    orderObj?.service_rating,
  );
  const [formError, setFormError] = useState<any>({});
  const [formData, setFormData] = useState({
    customer_feedback: orderObj?.customer_feedback,
    service_rating: orderObj?.service_rating,
    order_status: orderObj?.order_status,
  });
  const [loader, setLoader] = useState(false);

  const handleServiceItemChange = (updatedItems: any[]) => {
    setOrderServiceItems([...updatedItems]);
  };

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }
  const formModel = Schema.Model({
    customer_feedback: StringType(),
  });

  async function updateOrder(orderId: number, payload: any) {
    try {
      setLoader(true);
      if (onServeOrder) onServeOrder(orderId, payload);
      setLoader(false);
      setOpenModal("");
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  const orderChangeSubmitted = () => {
    let formFields: any = { ...formData };
    let payload = {
      customer_feedback: formFields["customer_feedback"],
      service_rating: formFields["service_rating"],
      order_status: formFields["order_status"],
      service_items: JSON.stringify(orderServiceItems),
    };
    updateOrder(+orderObj.id, payload);
  };

  useEffect(() => {}, []);

  return (
    <div>
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          backdrop
          content={t("LOADING")}
          vertical
        />
      )}
      <Container>
        <Content className="edit-cnt mt-2 content pt-0">
          <Form
            layout="inline"
            ref={formRef}
            model={formModel}
            className="serv-rdo"
            formError={formError}
            formDefaultValue={formData}
            onCheck={(e: any) => {
              setFormError(e);
            }}
            onSubmit={(e: any) => {
              if (e) {
                orderChangeSubmitted();
              }
            }}
            onChange={(data: any) => {
              setFormData(data);
            }}
          >
            {permission.service_rating && (
              <>
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item>
                    <Form.Group controlId="service_rating">
                      <Form.ControlLabel>
                        <b>
                          {t("CUSTOMER")} {t("RATING")}
                        </b>
                      </Form.ControlLabel>
                      <RadioGroup
                        inline
                        name="service_rating"
                        value={
                          isNotEmpty(serviceRatingVal)
                            ? serviceRatingVal.toString()
                            : ""
                        }
                        onChange={(e: any) => {
                          handleFormChanges({
                            path: "service_rating",
                            value: e,
                          });
                          setServiceRatingVal(e);
                        }}
                      >
                        {serviceRatingObjArr.map((item: any, index: number) => {
                          return <Radio value={item.value}>{item.label}</Radio>;
                        })}
                      </RadioGroup>
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item className="cst-fdbk-bx">
                    <Form.Group controlId="customer_feedback">
                      <Form.ControlLabel>
                        {t("CUSTOMER")} {t("FEEDBACK")}
                      </Form.ControlLabel>
                      <Form.Control
                        name="customer_feedback"
                        rows={10}
                        accepter={Textarea}
                        onChange={(e: any) => {
                          handleFormChanges({
                            path: "customer_feedback",
                            value: e,
                          });
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </>
            )}
            <div className="usr-form-btn mt-0">
              {showServiceDetails && (
                <>
                  <div className="address-bx" onClick={toggleServiceDetails}>
                    <h5>
                      {t("SERVICE")} {t("ITEMS")} {t("RATING")}
                    </h5>
                  </div>
                  <OrderServiceRateItems
                    orderServiceItems={orderServiceItems}
                    onServiceItemChange={handleServiceItemChange}
                  />
                </>
              )}
            </div>
            <div className="usr-form-btn mt-0">
              <Form.Group>
                <Button
                  appearance="primary"
                  onClick={(e: any) => setIsFormSubmitted(true)}
                  type="submit"
                >
                  {t("UPDATE")}
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={(e: any) => {
                    setIsFormSubmitted(false);
                    setOpenModal("");
                  }}
                  appearance="primary"
                  color="red"
                  type="reset"
                >
                  {t("CLOSE")}
                </Button>
                <Button
                  appearance="primary"
                  color="green"
                  type="button"
                  style={{ marginLeft: "10px" }}
                  onClick={toggleServiceDetails}
                >
                  {showServiceDetails ? t("HIDE") : t("SHOW")}
                  {" " + t("RATING") + " " + t("DETAILS")}
                </Button>
              </Form.Group>
            </div>
          </Form>
        </Content>
      </Container>
    </div>
  );
};

export default RateOrder;
